import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getById = createAsyncThunk("cfPay/getById",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/config/pembayaran/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findAll = createAsyncThunk("cfPay/findAll",
    async () => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/config/pembayaran`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const removeData = createAsyncThunk("cfPay/removeData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/config/pembayaran/${val}`
            const response = await jwtAuthAxios.delete(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const addData = createAsyncThunk("cfPay/addData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/config/pembayaran`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const updateData = createAsyncThunk("cfPay/updateData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/config/pembayaran`
            const response = await jwtAuthAxios.put(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

const initialState = {
    loadingCf: false,
    dataCf:{},
    dataCfList: [],
}

const configPembayaranSlice = createSlice({
    name: "configPembayaran",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getById.pending, (state) => {
                state.loadingCf = true;
            })
            .addCase(getById.fulfilled, (state, action) => {
                state.dataMataKuliah = action.payload;
                state.loadingCf = false;
            })
            .addCase(getById.rejected, (state, action) => {
                state.loadingCf = false;
            })
        builder
            .addCase(addData.pending, (state) => {
                state.loadingCf = true;
            })
            .addCase(addData.fulfilled, (state, action) => {
                state.dataCf = action.payload;
                state.loadingCf = false;
            })
            .addCase(addData.rejected, (state, action) => {
                state.loadingCf = false;
            })
        builder
            .addCase(updateData.pending, (state) => {
                state.loadingCf = true;
            })
            .addCase(updateData.fulfilled, (state, action) => {
                state.dataCf = action.payload;
                state.loadingCf = false;
            })
            .addCase(updateData.rejected, (state, action) => {
                state.loadingCf = false;
            })
        builder
            .addCase(removeData.pending, (state) => {
                state.loadingCf = true;
            })
            .addCase(removeData.fulfilled, (state, action) => {
                state.dataCf = action.payload;
                state.loadingCf = false;
            })
            .addCase(removeData.rejected, (state, action) => {
                state.loadingCf = false;
            })
        builder
            .addCase(findAll.pending, (state) => {
                state.loadingCf = true;
            })
            .addCase(findAll.fulfilled, (state, action) => {
                state.dataCfList = action.payload;
                state.loadingCf = false;
            })
            .addCase(findAll.rejected, (state, action) => {
                state.loadingCf = false;
            })

        ;
    }
})
export const configPembayaranSelectors = (state) => state.configPembayaran;
export default configPembayaranSlice.reducer;